
import type { IconProps } from 'src/types/icons';

// auth
import Email from 'src/assets/images/auth/email-icon';
import Password from 'src/assets/images/auth/password-icons';

// sidmenu
import OpenJobs from 'src/assets/images/side-menu/open-jobs-icon';
import Dashboard from 'src/assets/images/side-menu/dashboard-icon';
import ClosedJobs from 'src/assets/images/side-menu/closed-jobs-icon';
import Help from 'src/assets/images/side-menu/help-icon';
import CreateJobs from 'src/assets/images/side-menu/create-job-icon';
import Quotes from 'src/assets/images/side-menu/quotes-icon';
import TenantConversation from 'src/assets/images/side-menu/tenant-converstion-icon';
import Invoices from 'src/assets/images/side-menu/invoices-icon';
import Documents from 'src/assets/images/side-menu/documents-icon';
import PreferredVendors from 'src/assets/images/side-menu/preferred-vendors-icon';
import Amg from 'src/assets/images/side-menu/amg-icon';

// header
import MyProfileHeader from 'src/assets/images/header/my-profile-header-icon';
import SettingsHeader from 'src/assets/images/header/settings-header-icon';
import OpenJobsHeader from 'src/assets/images/header/open-jobs-header-icon';
import ClosedJobsHeader from 'src/assets/images/header/closed-jobs-header-icon';
import NotificationsHeader from 'src/assets/images/header/notifications-header-icon';
import PropertyManagersHeader from 'src/assets/images/header/property-managers-header-icon';
// global
import Upload from 'src/assets/images/global/upload-icon';
import NotificationXl from 'src/assets/images/global/notification-xl-icon';
import Close from 'src/assets/images/global/close-icon';
import Calendar from 'src/assets/images/global/calendar-icon';
import Logo from 'src/assets/images/global/logo-icon';
import Notification from 'src/assets/images/global/notification-icon';
import Settings from 'src/assets/images/global/settings-icon';
import LogoGrey from 'src/assets/images/global/logo-grey-icon';
import ChatBubble from 'src/assets/images/global/chat-bubble-icon';
import Profile from 'src/assets/images/global/profile-icon';
import OurPM from 'src/assets/images/global/our-pm-icon';
import Integrations from 'src/assets/images/global/integrations-icon';
import LogOut from 'src/assets/images/global/logout-icon';
import Filter from 'src/assets/images/global/filter-icon';
import CalendarSmall from 'src/assets/images/global/calendar-icon-small';
import Accordion from 'src/assets/images/global/accordion-icon';
import Appointment from 'src/assets/images/global/appointment-icon';
import User from 'src/assets/images/global/user-icon';
import Emergency from 'src/assets/images/global/emergency-icon';
import WorkOrder from 'src/assets/images/global/work-order-icon';
import Download from 'src/assets/images/global/download-icon';
import Edit from 'src/assets/images/global/edit-icon';
import StatusCompleted from 'src/assets/images/global/status-completed-icon';
import StatusUnpaid from 'src/assets/images/global/status-unpaid-icon';
import StatusVoided from 'src/assets/images/global/status-voided-icon';
import StatusVoid from 'src/assets/images/global/status-void-icon';
import StatusPartiallyPaid from 'src/assets/images/global/status-partially-paid-icon';
import StatusRefunded from 'src/assets/images/global/status-refunded';
import StatusPaymentSkipped from 'src/assets/images/global/status-payment-skipped';
import MakeReady from 'src/assets/images/global/make-ready-icon';

import ReviewIcon from 'src/assets/images/global/review-icon-green';
import PdfIcon from 'src/assets/images/global/pdf-icon';
import Archive from 'src/assets/images/global/archive-icon';
import Excel from 'src/assets/images/global/excel-icon';
import Plus from 'src/assets/images/global/plus-icon';
import ChatBubbleBig from 'src/assets/images/global/chat-bubble-icon-big';
import NotificationBig from 'src/assets/images/global/notification-icon-big';
import ConfirmBig from 'src/assets/images/global/confirm-icon-big';
import ExternalWorkOrder from 'src/assets/images/global/external-work-order-icon';
import AnsweringService from 'src/assets/images/global/answering-service-icon';
import PastDue from 'src/assets/images/global/past-due-icon';
import Outstanding from 'src/assets/images/global/outstanding-icon';
import Paid from 'src/assets/images/global/paid-icon';
import WalkThru from 'src/assets/images/global/walk-thru-icon';
import Scheduled from 'src/assets/images/global/scheduled-icon';
import Started2 from 'src/assets/images/global/started-icon2';

// status
import Started from 'src/assets/images/status/started-icon';
import Paused from 'src/assets/images/status/paused-icon';
import EnRoute from 'src/assets/images/status/en-route-icon';
import Stopped from 'src/assets/images/status/stopped-icon';
import Reached from 'src/assets/images/status/reached-icon';
import EnRouteStopped from 'src/assets/images/status/en-route-stopped';
import PendingReview from 'src/assets/images/status/pending-review';

// rating
import Star1 from 'src/assets/images/rating/star-1-icon';
import Star2 from 'src/assets/images/rating/star-2-icon';
import Star3 from 'src/assets/images/rating/star-3-icon';
import Star4 from 'src/assets/images/rating/star-4-icon';
import Star5 from 'src/assets/images/rating/star-5-icon';
import StarHalf from 'src/assets/images/rating/star-half';
import Star1Half from 'src/assets/images/rating/star-1-half';
import Star2Half from 'src/assets/images/rating/star-2-half';
import Star3Half from 'src/assets/images/rating/star-3-half';
import Star4Half from 'src/assets/images/rating/star-4-half';
import StarDisabled from 'src/assets/images/rating/star-disabled';

// help
import EmailUs from 'src/assets/images/help/email-us';
import LiveChat from 'src/assets/images/help/live-chat';
import PhoneCall from 'src/assets/images/help/phone-call';

// services
import Appliances from 'src/assets/images/services/appliances-icon';
import Plumbing from 'src/assets/images/services/plumbing-icon';

// open jobs
import PausedNotes from 'src/assets/images/open-jobs/paused-notes-icon';
import Returning from 'src/assets/images/open-jobs/returing-icon';

// Review
import NonReview from 'src/assets/images/review/non-review';
import Review from 'src/assets/images/review/review';

// Image Slider
import ImageSliderDeleteSvg from 'src/assets/images/image-slider/image-slider-delete-icon';
import ImageSliderPreviousButtonSvg from 'src/assets/images/image-slider/image-slider-previous-icon';
import ImageSliderNextButtonSvg from 'src/assets/images/image-slider/image-slider-next-icon';
import VideoPlayButtonSvg from 'src/assets/images/image-slider/video-play-icon';
import ImageSliderModalClose from 'src/assets/images/image-slider/modal-close-icon';

import ChevronLeft from 'src/assets/images/global/chevron-left-icon';
import GoBack from 'src/assets/images/open-jobs/go-back-icon';
import BuildBackFlag from 'src/assets/images/open-jobs/build-back-flag-icon';
import FlatPriceCatalog from 'src/assets/images/global/flat-price-catalog';
import FlatPriceCatalogSidebar from 'src/assets/images/global/flat-price-catalog-sidebar';
import StatusExpired from './global/expired-icon';
import OpenMakeReadies from './side-menu/open-make-readies';
import ClosedMakeReadies from './side-menu/closed-make-readies';
import OpenMakeReady from './global/open-make-ready';
import ClosedMakeReady from './global/close-make-ready';

export const PastDueIcon = (props: IconProps) => (
  <PastDue {...props} />
);
export const OutstandingIcon = (props: IconProps) => (
  <Outstanding {...props} />
);
export const PaidIcon = (props: IconProps) => (
  <Paid {...props} />
);
// sidemenu
export const OpenJobsIcon = (props: IconProps) => (
  <OpenJobs {...props} />
);

export const DashboardIcon = (props: IconProps) => (
  <Dashboard {...props} />
);

export const ClosedJobsIcon = (props: IconProps) => (
  <ClosedJobs {...props} />
);

export const HelpIcon = (props: IconProps) => (
  <Help {...props} />
);

export const CreateJobIcon = (props: IconProps) => (
  <CreateJobs {...props} />
);

export const QuotesIcon = (props: IconProps) => (
  <Quotes {...props} />
);

export const OpenMakeReadiesIcon = (props: IconProps) => (
  <OpenMakeReadies {...props} />
);

export const ClosedMakeReadiesIcon = (props: IconProps) => (
  <ClosedMakeReadies {...props} />
);

export const TenentConversationIcon = (props: IconProps) => (
  <TenantConversation {...props} />
);

export const InvoicesIcon = (props: IconProps) => (
  <Invoices {...props} />
);
export const DocumentsIcon = (props: IconProps) => (
  <Documents {...props} />
);
export const FlatPriceCatalogSidebarIcon = (props: IconProps) => (
  <FlatPriceCatalogSidebar {...props} />
);

export const PreferredVendorsIcon = (props: IconProps) => (
  <PreferredVendors {...props} />
);

export const AmgIcon = (props: IconProps) => (
  <Amg {...props} />
);

// header icons

export const MyProfileHeaderIcon = (props: IconProps) => (
  <MyProfileHeader {...props} />
);

export const SettingsHeaderIcon = (props: IconProps) => (
  <SettingsHeader {...props} />
);

export const OpenJobsHeaderIcon = (props: IconProps) => (
  <OpenJobsHeader {...props} />
);

export const ClosedJobsHeaderIcons = (props: IconProps) => (
  <ClosedJobsHeader {...props} />
);

export const NotificationsHeaderIcons = (props: IconProps) => (
  <NotificationsHeader {...props} />
);
export const PropertyManagersHeaderIcons = (props: IconProps) => (
  <PropertyManagersHeader {...props} />
);
// global icons

export const UploadIcon = (props: IconProps) => (
  <Upload {...props} />
);

export const NotificationXlIcon = (props: IconProps) => (
  <NotificationXl {...props} />
);

export const CloseIcon = (props: IconProps) => (
  <Close {...props} />
);

export const CalendarIcon = (props: IconProps) => (
  <Calendar {...props} />
);

export const LogoIcon = (props: IconProps) => (
  <Logo {...props} />
);

export const NotificationsIcon = (props: IconProps) => (
  <Notification {...props} />
);

export const SettingsIcon = (props: IconProps) => (
  <Settings {...props} />
);

export const LogGreyIcon = (props: IconProps) => (
  <LogoGrey {...props} />
);

export const ChatBubbleIcon = (props: IconProps) => (
  <ChatBubble {...props} />
);

export const ProfileIcon = (props: IconProps) => (
  <Profile {...props} />
);

export const OurPMIcon = (props: IconProps) => (
  <OurPM {...props} />
);

export const IntegrationsIcon = (props: IconProps) => (
  <Integrations {...props} />
);

export const LogoutIcon = (props: IconProps) => (
  <LogOut {...props} />
);

export const DownloadIcon = (props: IconProps) => (
  <Download {...props} />
);

export const StatusVoidIcon = (props: IconProps) => (
  <StatusVoid {...props} />
);
export const StatusExpiredIcon = (props: IconProps) => (
  <StatusExpired {...props} />
);
export const StatusVoidedIcon = (props: IconProps) => (
  <StatusVoided {...props} />
);
export const StatusPartiallyPaidIcon = (props: IconProps) => (
  <StatusPartiallyPaid {...props} />
);
export const StatusPaymentSkippedIcon = (props: IconProps) => (
  <StatusPaymentSkipped {...props} />
);
export const StatusRefundedIcon = (props: IconProps) => (
  <StatusRefunded {...props} />
);
export const ReviewIconGreen = (props: IconProps) => (
  <ReviewIcon {...props} />
);
// auth
export const EmailIcon = () => (
  <Email />
);

export const PasswordIcon = () => (
  <Password />
);

export const FilterIcon = (props: IconProps) => (
  <Filter {...props} />
);
export const CalendarIconSmall = (props: IconProps) => (
  <CalendarSmall {...props} />
);

export const AccordionIcon = (props: IconProps) => (
  <Accordion {...props} />
);

export const AppointmentIcon = (props: IconProps) => (
  <Appointment {...props} />
);

export const UserIcon = (props: IconProps) => (
  <User {...props} />
);

export const EmergencyIcon = (props: IconProps) => (
  <Emergency {...props} />
);

export const WorkOrderIcon = (props: IconProps) => (
  <WorkOrder {...props} />
);
export const StatusCompletedIcon = (props: IconProps) => (
  <StatusCompleted {...props} />
);
export const StatusUnpaidIcon = (props: IconProps) => (
  <StatusUnpaid {...props} />
);
export const EditIcon = (props: IconProps) => (
  <Edit {...props} />
);
// status

export const StartedIcon = (props: IconProps) => (
  <Started {...props} />
);
export const PausedIcon = (props: IconProps) => (
  <Paused {...props} />
);

export const EnRouteIcon = (props: IconProps) => (
  <EnRoute {...props} />
);

export const StoppedIcon = (props: IconProps) => (
  <Stopped {...props} />
);
export const ReachedIcon = (props: IconProps) => (
  <Reached {...props} />
);

export const EnRouteStoppedIcon = (props: IconProps) => (
  <EnRouteStopped {...props} />
);
export const PendingReviewIcon = (props: IconProps) => (
  <PendingReview {...props} />
);
// rating
export const Star1Icon = (props: IconProps) => (
  <Star1 {...props} />
);
export const Star2Icon = (props: IconProps) => (
  <Star2 {...props} />
);
export const Star3Icon = (props: IconProps) => (
  <Star3 {...props} />
);
export const Star4Icon = (props: IconProps) => (
  <Star4 {...props} />
);
export const Star5Icon = (props: IconProps) => (
  <Star5 {...props} />
);

export const StarHalfIcon = (props: IconProps) => (
  <StarHalf {...props} />
);
export const Star1HalfIcon = (props: IconProps) => (
  <Star1Half {...props} />
);
export const Star2HalfIcon = (props: IconProps) => (
  <Star2Half {...props} />
);
export const Star3HalfIcon = (props: IconProps) => (
  <Star3Half {...props} />
);
export const Star4HalfIcon = (props: IconProps) => (
  <Star4Half {...props} />
);
export const StarDisabledIcon = (props: IconProps) => (
  <StarDisabled {...props} />
);
export const EmailUsIcon = (props: IconProps) => (
  <EmailUs {...props} />
);

export const LiveChatIcon = (props: IconProps) => (
  <LiveChat {...props} />
);
export const PhoneCallIcon = (props: IconProps) => (
  <PhoneCall {...props} />
);

export const AppliancesIcon = (props: IconProps) => (
  <Appliances {...props} />
);

export const PlumbingIcon = (props: IconProps) => (
  <Plumbing {...props} />
);

export const PausedNotesIcon = (props: IconProps) => (
  <PausedNotes {...props} />
);

export const ReturningIcon = (props: IconProps) => (
  <Returning {...props} />
);

export const ArchiveIcon = (props: IconProps) => (
  <Archive {...props} />
);

export const ExcelIcon = (props: IconProps) => (
  <Excel {...props} />
);

export const PlusIcon = (props: IconProps) => (
  <Plus {...props} />
);

export const ChatBubbleBigIcon = (props: IconProps) => (
  <ChatBubbleBig {...props} />
);

export const NotificationBigIcon = (props: IconProps) => (
  <NotificationBig {...props} />
);
export const ConfirmBigIcon = (props: IconProps) => (
  <ConfirmBig {...props} />
);
export const ExternalWorkOrderIcon = (props: IconProps) => (
  <ExternalWorkOrder {...props} />
);

export const AnsweringServiceIcon = (props: IconProps) => (
  <AnsweringService {...props} />
);
export const FlatPriceCatalogIcon = (props: IconProps) => (
  <FlatPriceCatalog {...props} />
);

export const NonReviewICon = (props: IconProps) => (
  <NonReview {...props} />
);

export const ReviewICon = (props: IconProps) => (
  <Review {...props} />
);

export const GoBackIcon = (props: IconProps) => (
  <GoBack {...props} />
);

export const BuildBackFlagIcon = (props: IconProps) => (
  <BuildBackFlag {...props} />
);

export const PortableDocumentIcon = (props: IconProps) => (
  <PdfIcon {...props} />
);

export const WalkThruIcon = (props: IconProps) => (
  <WalkThru {...props} />
);

export const ScheduledIcon = (props: IconProps) => (
  <Scheduled {...props} />
);

export const StartedIcon2 = (props: IconProps) => (
  <Started2 {...props} />
);

export const MakeReadyIcon = (props: IconProps) => (
  <MakeReady {...props} />
);
export const OpenMakeReadyIcon = (props: IconProps) => (
  <OpenMakeReady {...props} />
);
export const ClosedMakeReadyIcon = (props: IconProps) => (
  <ClosedMakeReady {...props} />
);

export const ImageSliderDeleteIcon = (props: IconProps) => (
  <ImageSliderDeleteSvg {...props} />
);

export const ImageSliderPreviousIcon = (props: IconProps) => (
  <ImageSliderPreviousButtonSvg {...props} />
);

export const ImageSliderNextIcon = (props: IconProps) => (
  <ImageSliderNextButtonSvg {...props} />
);

export const VideoPlayButtonIcon = (props: IconProps) => (
  <VideoPlayButtonSvg {...props} />
);

export const ImageSliderModalCloseIcon = (props: IconProps) => (
  <ImageSliderModalClose {...props} />
);

export const OnSiteQuoteApprovalIcon = (props: IconProps) => (
  <svg {...props} width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.498047" y="0.814453" width="17.9177" height="18" rx="6" fill="#FF6200" />
    <ellipse cx="5.5998" cy="9.81438" rx="1.21894" ry="1.22454" fill="white" />
    <ellipse cx="9.45722" cy="9.81438" rx="1.21894" ry="1.22454" fill="white" />
    <ellipse cx="13.3146" cy="9.81438" rx="1.21894" ry="1.22454" fill="white" />
  </svg>

);

export const ChevronLeftIcon = (props: IconProps) => (
  <ChevronLeft {...props} />
);
